export default "__VITE_ASSET__DzyUdBpa__"